import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { SITE } from "../config";
import { scrollToSection } from "./Nav";

export default function Pricing() {
  return (
    <section id="pricing" data-testid="pricing-section" className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
      <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-start">
        <Reveal className="md:col-span-5">
          <div className="flex items-baseline gap-4">
            <span className="font-heading text-xl text-accent">03</span>
            <Eyebrow>Pricing</Eyebrow>
          </div>
          <h2 className="mt-6 font-heading font-medium tracking-tight leading-[1.05] text-4xl sm:text-5xl text-ink">
            Simple starting point.<br />Custom final quote.
          </h2>
          <p className="mt-6 text-base md:text-lg text-stone leading-relaxed max-w-md">
            Every project is different. Pricing depends on the number of pages,
            design complexity, functionality and integrations required.
          </p>
        </Reveal>

        <Reveal delay={0.12} className="md:col-span-7">
          <div className="border border-line p-8 md:p-12 bg-surface/60">
            <p className="text-xs uppercase tracking-[0.22em] font-bold text-stone">Websites starting from</p>
            <p data-testid="pricing-starting-price" className="mt-3 font-heading font-medium tracking-tight text-6xl md:text-7xl text-ink">
              {SITE.startingPrice}
            </p>
            <p className="mt-5 text-base text-stone leading-relaxed max-w-md">
              Most projects are individually quoted after an initial conversation —
              so you only pay for what your business actually needs.
            </p>
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); scrollToSection("#contact"); }}
              data-testid="pricing-cta-discuss"
              className="group mt-8 inline-flex items-center gap-2 bg-ink text-ivory font-semibold tracking-wide px-7 py-4 hover:bg-accent transition-colors duration-300"
            >
              Discuss Your Project
              <ArrowUpRight size={17} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
